import ChooseSeatTemplate from './choose-seat.html';
import ChooseSeatController from './choose-seat.controller';

function routeConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.public.btms.choose-seat', {
			url: '/choose-seat?subLineId&busId&date&returnId$returnBusId&returnDate&lang&u',
			template: ChooseSeatTemplate,
			controller: ChooseSeatController,
			controllerAs: 'vm',
			'resolve': {
				'Currencies': function(CurrencyComponent) {
					'ngInject';

					return CurrencyComponent.fetchCurrencies();
				},
				'Discount': function(DiscountComponent) {
					DiscountComponent.fetchDiscounts();
				},
				'SubLine': function ($stateParams, SubLineComponent) {
					'ngInject';
					const isPublic = true;

					return SubLineComponent.fetchSubLine($stateParams.subLineId, $stateParams.busId, $stateParams.date, isPublic);
				},
				'ReturnSubLine': function ($stateParams, SubLineComponent) {
					'ngInject';
					const isPublic = true;
					
					if ($stateParams.returnId) {
						return SubLineComponent.fetchSubLine($stateParams.returnId, $stateParams.returnBusId, $stateParams.returnDate, isPublic);
					}
				}
			}
		});
}

export default routeConfig;



/** WEBPACK FOOTER **
 ** ./client/public/main/choose-seat/choose-seat.route.js
 **/